import { __assign } from "tslib";
var itemsHelper = /** @class */ (function () {
    function itemsHelper(storageApi, summaryHelper) {
        this.storageApi = storageApi;
        this.summaryHelper = summaryHelper;
        this.items = null;
    }
    itemsHelper.prototype.getAllCartItems = function () {
        var _this = this;
        if (this.items) {
            return this.items;
        }
        else {
            var items_1 = {};
            var summary = this.summaryHelper.getItemsSummary();
            Object.keys(summary).forEach(function (uuid) {
                var item = _this.getCartItemFromStorage(uuid);
                if (item && item.uuid) {
                    items_1[uuid] = item;
                }
            });
            this.items = items_1;
            return items_1;
        }
    };
    itemsHelper.prototype.getCartItem = function (uuid) {
        var items = this.getAllCartItems();
        return items[uuid];
    };
    itemsHelper.prototype.addCartItem = function (item) {
        var _a;
        var items = this.getAllCartItems();
        this.setCartItemInStorage(item);
        this.items = __assign(__assign({}, items), (_a = {}, _a[item.uuid] = item, _a));
        return item;
    };
    itemsHelper.prototype.removeCartItem = function (item) {
        var items = __assign({}, this.getAllCartItems());
        this.removeCartItemFromStorage(item);
        delete items[item.uuid];
        this.items = items;
        return item;
    };
    itemsHelper.prototype.updateCartItem = function (_a) {
        var _b;
        var uuid = _a.uuid, metadata = _a.metadata, quantity = _a.quantity;
        var items = this.getAllCartItems();
        var item = items[uuid];
        if (item) {
            var newItem = __assign({}, item);
            metadata && (newItem.metadata = metadata);
            quantity && (newItem.quantity = quantity);
            this.setCartItemInStorage(newItem);
            this.items = __assign(__assign({}, items), (_b = {}, _b[uuid] = newItem, _b));
        }
        return this.items;
    };
    itemsHelper.prototype.setItemStatus = function (uuid, newStatus) {
        var _a;
        var items = this.getAllCartItems();
        var newItem = __assign(__assign({}, items[uuid]), { status: newStatus });
        this.setCartItemInStorage(newItem);
        this.items = __assign(__assign({}, items), (_a = {}, _a[uuid] = newItem, _a));
    };
    itemsHelper.prototype.removeCartItemFromStorage = function (item) {
        this.storageApi.removeItem(item.uuid);
    };
    itemsHelper.prototype.clearCartItemFromStorage = function (item) {
        this.storageApi.clear(item.uuid);
    };
    itemsHelper.prototype.setCartItemInStorage = function (item) {
        this.storageApi.setItem(item.uuid, JSON.stringify(item));
    };
    itemsHelper.prototype.getCartItemFromStorage = function (key) {
        var jsonItem = this.storageApi.getItem(key);
        return jsonItem && JSON.parse(jsonItem);
    };
    itemsHelper.prototype.clearAll = function () {
        var _this = this;
        var summary = this.summaryHelper.getItemsSummary();
        Object.keys(summary).forEach(function (uuid) {
            return _this.clearCartItemFromStorage({ uuid: uuid });
        });
        this.items = null;
    };
    return itemsHelper;
}());
export default itemsHelper;
//# sourceMappingURL=cartItemsHelper.js.map